import React from "react";
import { BoxWrapper, DashboardTitle, DashboardWrapper } from "../styles";
import TableSection from "../../../components/table/TableSection";
import { FiBiSessionsTableData } from "./table-data";
import { useGetAllSession } from "../../../../../hooks/ai/useAI";

const FibiSessions = () => {
  const { data, isError, isLoading } = useGetAllSession();

  return (
    <DashboardWrapper>
      <DashboardTitle>My FiBi Sessions</DashboardTitle>
      <BoxWrapper>
        <TableSection
          dataItems={data}
          tableData={FiBiSessionsTableData()}
          isError={isError}
          isLoading={isLoading}
        />
      </BoxWrapper>
    </DashboardWrapper>
  );
};

export default FibiSessions;
